<template>
  <div class="act-liveness-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="liveness-content" :style="`margin-top:-${barHeight + 46}px`">
      <img v-if="$i18n.locale === 'es'" class="banner-img" src="./images/banner-es.png" />
      <img v-else="$i18n.locale === 'en'" class="banner-img" src="./images/banner-en.png" />

      <div class="reward-table">
        <div class="reward-table-item reward-table-head">
          <div>{{ $t('lang.commonM.k120') }}</div>
          <div>{{ $t('lang.commonM.k121') }}</div>
          <div>{{ $t('lang.mybean.bonus') }}</div>
        </div>
        <div class="reward-table-item tr-bg2">
          <div>L0-L2</div>
          <div>L3</div>
          <div>
            800
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg3">
          <div>L0-L3</div>
          <div>L4</div>
          <div>
            2,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg2">
          <div>L0-L4</div>
          <div>L5</div>
          <div>
            5,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg3">
          <div>L0-L5</div>
          <div>L6</div>
          <div>
            10,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg2">
          <div>L0-L6</div>
          <div>L7</div>
          <div>
            20,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg3">
          <div>L0-L7</div>
          <div>L8</div>
          <div>
            40,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg2">
          <div>L0-L8</div>
          <div>L9</div>
          <div>
            70,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
        <div class="reward-table-item tr-bg3">
          <div>L0-L9</div>
          <div>L10</div>
          <div>
            100,000
            <img :src="getMatchImg('beans')" />
          </div>
        </div>
      </div>

      <div class="tips-bg">
        <div class="tips-tit">{{ $t('lang.commonM.k122') }}</div>
        <div class="tips-con">
          <span class="tips-order">1.</span>
          {{ $t('lang.commonM.k123') }}
        </div>
        <div class="tips-con">
          <span class="tips-order">2.</span>
          {{ $t('lang.commonM.k124') }}
        </div>
        <div class="tips-con">
          <span class="tips-order">3.</span>
          {{ $t('lang.commonM.k125') }}
          <i>01/09/2025 00:05:00</i>
        </div>
      </div>

      <div class="rules-btn" @click="toRules">{{ $t('lang.commonM.k126') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    toRules() {
      this.$router.push({ path: '/liveness-rules' })
    }
  }
}
</script>
<style lang="scss" scoped>
.act-liveness-root {
  width: 100%;
  min-height: 100vh;
  background: #9d3cff;

  .custom-nav-block {
    background-color: transparent;
  }

  .liveness-content {
    .banner-img {
      width: 100%;
      height: 240px;
    }

    .reward-table {
      width: 343px;
      margin: -35px auto 0;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
      .reward-table-item {
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: #ffffff;
        text-align: center;
        font-family: 'BarlowSemiCondensed-Regular';
        font-size: 19px;
        font-weight: 500;
        letter-spacing: 0.07px;
        height: 37px;

        &:last-child {
          border-bottom-left-radius: 12px;
          border-bottom-right-radius: 12px;
        }

        img {
          width: 20px;
          height: 20px;
          margin: 0 3px;
        }
        div {
          &:nth-child(1) {
            width: 120px;
          }
          &:nth-child(2) {
            flex: 1;
          }
          &:nth-child(3) {
            width: 100px;
          }
        }
      }
      .reward-table-head {
        font-family: Oswald-Regular;
        background: #7200e6;
      }
      .tr-bg2 {
        background: rgba(255, 255, 255, 0.1);
      }
      .tr-bg3 {
        background: rgba(255, 255, 255, 0.2);
      }
    }

    .tips-bg {
      width: 375px;
      height: 153px;
      padding: 16px;
      background: url(./images/bg.png) center center / 100% 100% no-repeat;
      .tips-tit {
        color: #fff;
        font-family: 'BarlowSemiCondensed-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 15px;
        letter-spacing: 0.07px;
        margin-top: 20px;
        margin-bottom: 6px;
      }
      .tips-con {
        color: rgba(255, 255, 255, 0.8);
        font-family: 'BarlowSemiCondensed-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.07px;
        &:last-child {
          color: #ffffff;
          i {
            font-style: italic;
          }
        }

        .tips-order {
          display: inline-block;
          width: 20px;
          text-indent: 7px;
        }
      }
    }

    .rules-btn {
      width: 235px;
      line-height: 56px;
      margin: 0 auto;

      border-radius: 56px;
      border: 2px solid #7700ab;
      background: linear-gradient(92deg, #ff9b32 5.52%, #ff1fc1 93.21%);
      box-shadow: 0 0 15px 3px #fffad0 inset;

      color: #fff;
      text-align: center;
      font-family: 'AntonSC-Regular';
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.07px;
    }
  }
}
</style>
